import React from 'react';

import styles from './PanelContainer.module.scss';
export const FormTitle = ({ className, ...props }: React.ComponentPropsWithoutRef<'h2'>) => (
  <h2
    className={className ? `${styles['form-title']} ${className}` : styles['form-title']}
    {...props}
  />
);

export const HasServerResponse = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={
      className ? `${styles['has-server-response']} ${className}` : styles['has-server-response']
    }
    {...props}
  />
);

export const FieldContainer = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['field-container']} ${className}` : styles['field-container']}
    {...props}
  />
);
